import { useEffect } from 'react';
import { X } from 'lucide-react';
import clsx from 'clsx';
import { useUiStore } from '@/store/uiStore';
import { t } from '@/lib/i18n';
import styles from './Toast.module.css';

export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  return (
    <div className={styles.viewport} role="region" aria-label={t('toast.regionLabel')}>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} {...toast} onDismiss={() => dismiss(toast.id)} />
      ))}
    </div>
  );
}

function ToastItem({
  id,
  tone,
  title,
  body,
  onDismiss,
}: {
  id: string;
  tone: 'success' | 'error' | 'info';
  title: string;
  body?: string;
  onDismiss: () => void;
}) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 4000);
    return () => clearTimeout(timer);
  }, [id, onDismiss]);

  return (
    <div className={clsx(styles.toast, styles[tone])} role="status">
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        {body ? <div className={styles.message}>{body}</div> : null}
      </div>
      <button className={styles.dismiss} onClick={onDismiss} aria-label={t('toast.closeLabel')}>
        <X size={16} />
      </button>
    </div>
  );
}
